// import { tableMixins } from '@/utils/tableMixins.js';
// mixins: [infoTagsMixins, tableMixins],

import pagination from '@/common/components/pagination';
import search_infoTags from '@/common/components/search/search_infoTags';
import search_btnGroup from '@/common/components/search/search_btnGroup';
import menuAuthBtn from '@/common/components/menuAuthBtn';
import delPopConfirm from '@/common/components/table/delPopConfirm';
import operation from '@/common/components/table/operation';
import statusTabs from '@/common/components/table/status_tabs.vue';
import searchTool from '@/common/components/search-tool.vue';

export const tableMixins = {
    components: {
        pagination,
        search_infoTags,
        search_btnGroup,
        menuAuthBtn,
        delPopConfirm,
        statusTabs,
        searchTool,
        operation,
    },
    computed: {
        menu_id() {
            return this.$store.state.menu.menu_id ?
                this.$store.state.menu.menu_id :
                localStorage.getItem('menu_id');
        },
        height() {
            return `calc(100% - 40px - 80px${this.hasSearchCondition && ' - 32px' || ''}${
                (this.statusList instanceof Array &&
                    this.statusList.length > 0 &&
                    ' - 40px') ||
                ''
            }${document.title.startsWith('CMOffer - System - ') && ' - 32px' || ''})`;
        },
        searchList() {
            return [
                {
                    label: this.$i18n.locale == 'zh' ? '关键字' : 'Keyword',
                    key: 'keyword',
                    type: 'input',
                },
                {
                    label: this.$i18n.locale == 'zh' ? '状态' : 'Status',
                    key: 'status',
                    type: 'select',
                    props: {
                        list: this.statusList,
                        nameKey: 'keyword',
                        valueKey: 'status',
                    },
                },
            ];
        },
    },
    data() {
        return {
            checkFixed: false,
            operationFixed: false,

            // 列表相同数据
            tableData: [],
            paginationData: {
                page: 1,
                'per-page': 20,
                total: '',
            },
            status: '0',
            tableItem: {},
            statusList: [],
            menuAuth: [],
            loading: false,
            drawerVisible: false,
            hasSearchCondition: false,
        };
    },
    methods: {
        isHorizontalSrcoll() {
            let headerWrapper = document.querySelector('.el-table__header-wrapper');
            let header = document.querySelector('.el-table__header');
            let headerWrapperWidth = headerWrapper.offsetWidth;
            let headerWidth = header.offsetWidth;
            if (headerWidth > headerWrapperWidth) {
                // console.log('出现横向滚动')
                this.checkFixed = true;
                this.operationFixed = 'right';
            } else {
                // console.log('没有横向滚动')
                this.checkFixed = false;
                this.operationFixed = false;
            }
        },
        // 关闭drawer
        closeDrawer() {
            this.$refs.searchTool.$refs && this.$refs.searchTool.$refs.drawer.closeDrawer();
        },
        paginationChange(paginationData) {
            this.paginationData = paginationData;
            this.$refs.tableData.bodyWrapper.scrollTop = 0;
        },
    },
    mounted() {
        /* this.$nextTick(()=>{
            this.isHorizontalSrcoll();
        })
        window.onresize = () => {
            this.isHorizontalSrcoll();
        } */
    },
    activated() {
        if (this.$route.query.keyword) {
            // 通过url的参数，这是搜索框的值进行搜索
            this.$set(this.searchForm, 'keyword', this.$route.query.order_sn || this.$route.query.keyword);
        }
    }
};